// this is the left panel and right content layout
import { Outlet, Navigate, useLocation } from "react-router-dom"
import Navbar from "../navigation/Navbar"
import ReloadButton from "@/components/ReloadButton"
import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
import AdminNavbar from "@/navigation/admin/AdminNavbar";
import RewardsHeader from "./header/RewardsHeader";

export default function Layout() {
    const location = useLocation();
    const { role } = useSelector((state: ReduxState) => state.program);

    // Redirect to default page based on role when accessing root path
    if (location.pathname === '/') {
        if (role === 'external_sales') {
            return <Navigate to="/profile" replace />;
        } else {
            return <Navigate to="/rewards-claims" replace />;
        }
    }
    const getAdminNav = () => {
        return (
            <AdminNavbar />
        )
    }
    const getCustomerNav = () => {
        return (
            <Navbar />
        )
    }

    return (
        <>
            <ReloadButton />
            <div className="flex flex-col lg:flex-row h-dvh">
                <div>
                    {role === 'admin' ? getAdminNav() : getCustomerNav()}
                </div>
                <div className="grow min-w-0 min-h-0 flex flex-col bg-gray-50">
                    <RewardsHeader />
                    <div className="flex-1 min-h-0 overflow-auto">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    )
}
